// extracted by mini-css-extract-plugin
module.exports = {"link":"styles__link--2mEVX","activeLink":"styles__activeLink--3Wd3A"};